"use client"

import { ArrowUpCircle, Download, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useUpdateCheck } from "@/hooks/use-update-check"

export function UpdateNotification() {
  const { updateInfo, dismiss } = useUpdateCheck()

  if (!updateInfo) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="bg-card border border-primary/30 rounded-xl shadow-2xl p-4 flex flex-col gap-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2 text-primary">
            <ArrowUpCircle className="h-5 w-5 flex-shrink-0" />
            <span className="font-semibold text-sm">Mise à jour disponible</span>
          </div>
          <button
            onClick={dismiss}
            className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span className="bg-muted px-2 py-0.5 rounded text-xs font-mono">
            v{updateInfo.currentVersion}
          </span>
          <span className="text-muted-foreground">→</span>
          <span className="bg-primary/15 text-primary px-2 py-0.5 rounded text-xs font-mono font-semibold">
            v{updateInfo.latestVersion}
          </span>
        </div>

        <p className="text-xs text-muted-foreground leading-relaxed">
          Une nouvelle version de VisualGrid est disponible. Téléchargez-la pour profiter des dernières améliorations.
        </p>

        <div className="flex gap-2">
          <Button
            size="sm"
            className="flex-1 gap-1.5"
            onClick={() => {
              window.open(updateInfo.downloadsUrl, '_blank')
              dismiss()
            }}
          >
            <Download className="h-3.5 w-3.5" />
            Télécharger
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={dismiss}
            className="text-muted-foreground"
          >
            Plus tard
          </Button>
        </div>
      </div>
    </div>
  )
}
